import TableContainer from "components/newTables/TableContainer"
import React, { useMemo } from "react"
import { Button } from "reactstrap"

export default function Table({
  content,
  page,
  size,
  count,
  params,
  setParams,
  handleEdit,
}) {
  const listDataTable = useMemo(() => {
    if (!content) return []

    return content.map((m, idx) => ({
      id: m.id,
      supplierName: m.supplierName,
      orderDate: m.orderDate,
      year: m.year,
      seasonName: m.seasonName,
      fabricCompanyName: m.fabricCompanyName,
      fabricNumber: m.fabricNumber,
      unitPrice: m.unitPrice ? m.unitPrice.toLocaleString("ja-JP") : "",
      scale: m.scale,
      fabricCost: m.fabricCost ? m.fabricCost.toLocaleString("ja-JP") : "",
      qty42: m.qty42,
      qty44: m.qty44,
      qty46: m.qty46,
      qty48: m.qty48,
      qty50: m.qty50,
      qty52: m.qty52,
      qty54: m.qty54,
      total: m.total,
      scheduledDeliveryDate: m.scheduledDeliveryDate,
      status: m.status,
    }))
  }, [content])

  const columns = useMemo(
    () => [
      { Header: "取引先", accessor: "supplierName" },
      { Header: "受注日", accessor: "orderDate" },
      { Header: "年度", accessor: "year" },
      { Header: "シーズン", accessor: "seasonName" },
      { Header: "生地商社", accessor: "fabricCompanyName" },
      { Header: "生地番号", accessor: "fabricNumber" },
      { Header: "生地単価", accessor: "unitPrice" },
      { Header: "用尺", accessor: "scale" },
      { Header: "生地代", accessor: "fabricCost" },
      { Header: "42", accessor: "qty42" },
      { Header: "44", accessor: "qty44" },
      { Header: "46", accessor: "qty46" },
      { Header: "48", accessor: "qty48" },
      { Header: "50", accessor: "qty50" },
      { Header: "52", accessor: "qty52" },
      { Header: "54", accessor: "qty54" },
      { Header: "合計", accessor: "total" },
      { Header: "予定納品日", accessor: "scheduledDeliveryDate" },
      { Header: "ステータス", accessor: "status" },
      {
        Header: "",
        accessor: "action",
        Cell: ({ cell }) => {
          return (
            <Button
              className="button"
              onClick={() => handleEdit(cell.row.original.id)}
            >
              詳細
            </Button>
          )
        },
      },
    ],
    []
  )

  return (
    <>
      <TableContainer
        page={page}
        size={size}
        count={count}
        params={params}
        setParams={setParams}
        columns={columns}
        data={listDataTable}
        pagination
      />
    </>
  )
}
